import React from 'react';
import ReactDOM from 'react-dom';
import './index.scss';
import theme from '@css/theme';
import { stores } from '@stores/index';
import { Provider } from 'mobx-react';
import { ThemeProvider } from 'styled-components';
import { ErrorBoundary } from '@lib/bugsnag';
import AppRouter from './auth/appRouter';
import { loadScripts } from './scripts';
import { datadogRum } from '@datadog/browser-rum';
import { DATADOG_APP_ID, DATADOG_CLIENT_TOKEN } from '@config';

ReactDOM.render(
  <ErrorBoundary>
    <Provider {...stores}>
      <ThemeProvider theme={theme}>
        <div className="App">
          <AppRouter />
        </div>
      </ThemeProvider>
    </Provider>
  </ErrorBoundary>,
  document.getElementById('root'),
);

datadogRum.init({
  applicationId: DATADOG_APP_ID,
  clientToken: DATADOG_CLIENT_TOKEN,
  site: 'datadoghq.com',
  service: 'control-plane-webapp',
  env: process.env.REACT_APP_ENV,
  version: '1.0.0',
  sampleRate: 100,
  replaySampleRate: 100,
  trackInteractions: true,
  defaultPrivacyLevel: 'mask-user-input',
});

loadScripts();
